<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card class="table-responsive">
          <div slot="header">
            <i class="fa fa-list"></i> Centros
            <router-link
              class="pull-right btn btn-sm btn-success text-white"
              to="/centros/crear-centro"
            >
              <i class="fa fa-plus" /> Nuevo
            </router-link>
          </div>
          <table class="table table-condensed table-striped table-hover">
            <thead>
              <tr>
                <th>
                  <a @click="ordenar('codigo')" href="#">
                    Código
                    <span v-show="order_by == 'codigo'">
                      <i
                        class="fa fa-sort-alpha-asc"
                        v-show="!tipoOrder == 'asc'"
                      />
                      <i
                        class="fa fa-sort-alpha-desc"
                        v-show="tipoOrder == 'asc'"
                      />
                    </span>
                  </a>

                  <input
                    type="text"
                    class="form-control"
                    v-model="model.codigo"
                    v-on:keyup.enter="getCentros()"
                  />
                </th>
                <th>
                  <a @click="ordenar('nombre')" href="#">
                    Nombre
                    <span v-show="order_by == 'nombre'">
                      <i
                        class="fa fa-sort-alpha-asc"
                        v-show="!tipoOrder == 'asc'"
                      />
                      <i
                        class="fa fa-sort-alpha-desc"
                        v-show="tipoOrder == 'asc'"
                      />
                    </span>
                  </a>

                  <input
                    type="text"
                    class="form-control"
                    v-model="model.nombre"
                    v-on:keyup.enter="getCentros()"
                  />
                </th>
                <th>
                  <div>
                    <a @click="ordenar('empresa_id')" href="#">
                      Empresa
                      <span v-show="order_by == 'empresa_id'">
                        <i
                          class="fa fa-sort-alpha-asc"
                          v-show="!tipoOrder == 'asc'"
                        />
                        <i
                          class="fa fa-sort-alpha-desc"
                          v-show="tipoOrder == 'asc'"
                        />
                      </span>
                    </a>
                    <b-form-select
                      v-model="model.empresa_id"
                      :options="empresas"
                      value-field="id"
                      text-field="nombre"
                      @change="getCentros"
                    ></b-form-select>
                  </div>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in registros" :key="item.id">
                <td>{{ item.codigo }}</td>
                <td>{{ item.nombre }}</td>
                <td>{{ item.empresa.nombre }}</td>
                <td>
                  <router-link class="pull-right" :to="'/centros/' + item.id">
                    <i class="fa fa-pencil" />
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination
            v-show="totalRows > 0"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="mt-4"
            @input="getCentros"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "EmpresaTable",
  data: () => {
    return {
      empresas: [],
      cargando: false,
      tipoOrder: "asc",
      order_by: null,
      registros: [],
      model: {
        codigo: null,
        nombre: null,
        empresa_id: null
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1
    };
  },
  beforeMount() {
    this.getCentros();
    this.getEmpresas();
  },
  methods: {
    async ordenar(campo) {
      this.tipoOrder =
        this.tipoOrder == "asc"
          ? this.tipoOrder == "dec"
          : this.tipoOrder == "asc";
      this.order_by = campo;
      this.getCentros();
    },
    async getCentros() {
      try {
        this.registros = [];
        this.cargando = true;
        // eslint-disable-next-line no-undef
        let { data } = await axios.post("/api/catalogos/centros", {
          perPage: this.perPage,
          currentPage: this.currentPage,
          order_by: this.order_by,
          tipoOrder: this.tipoOrder ? "asc" : "desc",
          model: this.model
        });
        let datos = data.data ? data.data : [];

        this.registros = datos;
        this.cargando = false;

        this.totalRows = data.total;
      } catch (error) {
        console.log(error);
      }
    },
    async getEmpresas() {
      try {
        // eslint-disable-next-line no-undef
        let { data } = await axios.get("/api/catalogos/empresas-list");
        this.empresas = data.data;
        //Unshift Agrega el elemento en el indice 0
        this.empresas.unshift({ id: null, nombre: "Seleccione" });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style>
.table th,
.table td {
  padding: 0.3em;
}
</style>
